var map = {
	"./bookshelf.png": 5168,
	"./deadbody.png": 960,
	"./deskbook.png": 440,
	"./mapae.png": 37,
	"./missing1_neutral.png": 1408,
	"./missing2_neutral.png": 3244,
	"./missing3_neutral.png": 8832,
	"./missing4_neutral.png": 3992,
	"./tea.png": 6244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1060;